import "./App.css";
import Preloader from "./Components/Preloader";
import Header from "./Components/Header";
import About from "./Components/About";
import Resume from "./Components/Resume";
import Portfolio from "./Components/Portfolio";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
import LinesGrid from "./Components/LinesGrid";

function App() {
  return (
    <div className="page">
      <Preloader />
      <Header />
      <div className="container">
        <About />
        <Resume />
        <Portfolio />
        <Contact />
        <Footer />
        <LinesGrid />
      </div>
    </div>
  );
}

export default App;
